import React, { useRef, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';

import { useLocation, useNavigate } from 'react-router-dom/';
import Loader from '../common/Loader';
import LoaderButton from '../common/LoaderButton';
import ConfirmationModal from '../common/ConfirmationModal';

export default function ViewToEditForm({
  initialValues,
  formValidationSchema,
  formContents,
  t,
  handleUpdate,
  handleDelete,
  canUpdateItem,
  isEditing,
  setIsEditing,
  uneditedValues,
  deleteMessage,
  hideForm,
  disableEdit = false,
  validate = () => ({}),
  isCreate = false,
  formRef = useRef(null),
  deleteType = 'delete',
  readonly = false,
}) {
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={formValidationSchema}
      innerRef={formRef}
      onSubmit={handleUpdate}
      validate={validate}
      enableReinitialize
    >
      {({ errors, dirty, handleSubmit, isSubmitting, resetForm, values }) => {
        return (
          <Form noValidate autoComplete="new-password" onSubmit={handleSubmit}>
            {isSubmitting && <Loader />}

            {formContents({ values })}

            <div className="border-top actions d-flex flex-wrap justify-content-end mx-0 mb-0 mt-4 p-0  mb-md-n4 p-md-4">
              {isEditing && canUpdateItem && (
                <>
                  {!isCreate && (
                    <Button
                      variant={deleting ? 'warning' : 'outline-warning'}
                      disabled={deleting}
                      onClick={() => setDeleting(true)}
                      className="px-4 me-0 me-auto"
                    >
                      {t(
                        deleting
                          ? `common:buttons.${deleteType}InProgress`
                          : `common:buttons.${deleteType}`
                      )}
                    </Button>
                  )}

                  <Button
                    variant="outline-light"
                    onClick={() => {
                      setIsEditing(false);
                      resetForm(uneditedValues);
                      if (hideForm) hideForm();
                      if (isCreate && location.pathname.toLowerCase().includes('new')) {
                        navigate(-1);
                      }
                    }}
                    className={`px-4 ${isCreate ? 'me-auto' : 'ms-0'}`}
                  >
                    {t('common:buttons.cancel')}
                  </Button>

                  <LoaderButton
                    variant="primary"
                    loading={isSubmitting ? true : undefined}
                    disabled={
                      initialValues.frozen ||
                      deleting ||
                      isSubmitting ||
                      Object.keys(errors).length > 0 ||
                      !dirty
                    }
                    type="submit"
                    className="ms-0 ms-md-3 px-4"
                  >
                    {t('common:buttons.save')}
                  </LoaderButton>
                </>
              )}

              {!isEditing && hideForm && (
                <Button
                  variant="outline-light"
                  onClick={hideForm}
                  className="px-4 me-3"
                  disabled={disableEdit}
                >
                  {t('common:buttons.hide')}
                </Button>
              )}

              {!isEditing && !readonly && (
                <Button
                  variant="outline-light"
                  onClick={() => setIsEditing(true)}
                  className="px-4 ms-0"
                  disabled={disableEdit}
                >
                  {t('common:buttons.edit')}
                </Button>
              )}
            </div>

            {deleting && (
              <ConfirmationModal
                show={deleting}
                data={initialValues}
                title={t('common:buttons.confirm')}
                message={deleteMessage}
                buttonLabel={t(`common:buttons.${deleteType}`)}
                buttonLoadingLabel={t(`common:buttons.${deleteType}InProgress`)}
                buttonVariant="warning"
                onHide={() => setDeleting(false)}
                handleSubmit={() => {
                  handleDelete();
                  setDeleting(false);
                }}
                setShow={setDeleting}
              />
            )}
          </Form>
        );
      }}
    </Formik>
  );
}
